import moment, { isDate } from "moment";

export const protectRoute =
  sessionStorage.getItem("user") && JSON.parse(sessionStorage.getItem("user"));

function numberToOrdinal(n) {
  const suffixes = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}

export function convertNumberToWord(n) {
  const words = [
    "zeroth",
    "First",
    "Second",
    "Third",
    "Fourth",
    "Fifth",
    "sixth",
    "Seventh",
    "Eighth",
    "Ninth",
    "Tenth",
  ];
  return words[n] || numberToOrdinal(n);
}

export function validationRules(validationObj, label, type) {
  let validations;
  let validationArray = [];
  if (validationObj) {
    validations = Object.keys(validationObj);
    validations = validations.filter(
      (validation) => !validation.includes("message")
    );
  }

  if (type !== "file") {
    if (
      validations.find(
        (validation) =>
          validation === "required" && validationObj[validation] === true
      )
    ) {
      validationArray.push({
        required: true,
        message: `${label} is required.`,
      });
    }
    if (validations.find((validation) => validation === "pattern")) {
      validationArray.push({
        validator: validateInput.bind(
          null,
          new RegExp(validationObj["pattern"]),
          validationObj["pattern_message"]
        ),
      });
    }
    if (
      validations.find(
        (validation) =>
          validation.includes("min_length") && !validation.includes("message")
      )
    ) {
      const value = validations.find(
        (validation) =>
          validation.includes("min_length") && !validation.includes("message")
      );

      validationArray.push({
        min: validationObj[value],
        message: `Minimum length should be there.`,
      });
    }

    if (
      validations.find(
        (validation) =>
          validation.includes("max_length") && !validation.includes("message")
      )
    ) {
      const value = validations.find(
        (validation) =>
          validation.includes("max_length") && !validation.includes("message")
      );

      validationArray.push({
        max: validationObj[value],
        message: `Maximum length should be there.`,
        // .split("")
        // .map((e, i) => (i === 0 ? e.toUpperCase() : e))
        // .join(""),
      });
    }
    if (validations.find((validation) => validation === "min")) {
      validationArray.push({
        validator: validateMinNumber.bind(
          null,
          `${label} can be ${validationObj["min"]} at minimun`,validationObj["min"]
        ),
      });
    }
    if (validations.find((validation) => validation === "max")) {
      validationArray.push({
        validator: validateMaxNumber.bind(
          null,
          `${label} can be ${validationObj["max"]} at maximum`,validationObj["max"]
        ),
      });
    }
  }
  return validationArray;
}

const validateInput = (regexPattern, message, _, value) => {
  if (+new Date(value)) {
    value = moment(value).format("MM/DD/YYYY");
  }
  if (value && !regexPattern.test(value)) {
    return Promise.reject(new Error(message));
  }
  return Promise.resolve();
};

const validateMinNumber = (message,minValue, _, value) => {
  if (value < minValue) {
    return Promise.reject(new Error(message));
  }
  return Promise.resolve();
};

const validateMaxNumber = (message,maxValue, _, value) => {
  if (value > maxValue) {
    return Promise.reject(new Error(message));
  }
  return Promise.resolve();
};
